













































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "AgendaGesdenPanel" })
export default class AgendaGesdenPanel extends Vue {
  @Prop({ default: () => [] }) public bandejaGesden!: any[];
  @Prop({ required: true }) public bandejaCss!: (estado: string) => string;
  @Prop({ required: true }) public stateInfo!: (estado: string) => { icon: string; vuetifyColor: string; hexColor: string; actionLabel: string };
  @Prop({ required: true }) public formatDateTime!: (value: any) => string;
}
